import React, { useEffect, useState } from "react";
import HeroSection from "./pages/HeroSection";
import ReferAndEarn from "./pages/ReferAndEarn";
import WhoCanJoin from "./pages/WhoCanJoin";
import Faq from "./pages/Faq";
import { fetchData } from "./components/Axios";
import Footer from "./pages/Footer";
const App = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const getData = async () => {
      const result = await fetchData();
      setData(result);
      setLoading(false);
    };
    getData();
  }, []);
  if (loading || !data) {
    return (
      <div>
        <div className="flex space-x-2 justify-center items-center bg-white h-screen ">
          <span className="sr-only">Loading...</span>
          <div className="h-8 w-8 bg-blue rounded-full animate-bounce [animation-delay:-0.3s]"></div>
          <div className="h-8 w-8 bg-blue rounded-full animate-bounce [animation-delay:-0.15s]"></div>
          <div className="h-8 w-8 bg-blue rounded-full animate-bounce"></div>
        </div>
      </div>
    );
  }
  return (
    <div>
      <HeroSection landingPageData={data?.landingPageData} />
      <ReferAndEarn landingPageData={data?.landingPageData} />
      <WhoCanJoin landingPageData={data?.landingPageData} />
      <Faq landingPageData={data?.landingPageData} />
      <Footer landingPageData={data?.landingPageData} />
    </div>
  );
};
export default App;
